module.exports = {
	"account.user.driving.licence.already.exist": "Ce permis de conduire est déjà relié à un compte existant",
	"account.user.login.already.exist": "Cet e-mail est déjà utilisé par un autre compte.",
	"account.user.suspended": "Impossible d'effectuer cette action car l'utilisateur est suspendu",
	"action.add.payment": "Ajouter une carte",
	"action.complete.my.account": "Complétez mon compte",
	"action.confirm.welcome.msg": "Allons-y",
	"action.create.my.account": "Créer mon compte",
	"action.search.update.bookings": "Vérifier les disponibilités",
	"action.update.payment": "Mettre à jour le moyen de paiement",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "En cliquant sur \"Confirmer\", vous déclarez sur l'honneur accepter les conditions générales d'utilisation du service et être actuellement titulaire d'un permis de conduire valide si vous utilisez le service d'auto-partage. Plus dans le {link}.",
	"booking.accept_usage_terms.title": "Conditions générales d'utilisation",
	"booking.action.cancel.forbidden": "Vous ne pouvez plus annuler la réservation",
	"booking.action.edit.forbidden": "Vous ne pouvez plus modifier la réservation",
	"booking.add.calendar": "Ajouter à mon calendrier",
	"booking.confirm": "Confirmer la réservation",
	"booking.confirm_and_pay": "Confirmer et payer",
	"booking.deposit": "Dépôt de garantie",
	"booking.deposit.b": "Une empreinte bancaire d'un montant de {damageSafetyDeposit} {currency} sera effectuée lorsque vous confirmerez votre réservation. \nCelle-ci permettant de couvrir d'éventuels dégâts occasionnés sur le véhicule durant votre réservation.\n\nSans dépassement ni dégât, ne seront débités que les {bookingPrice} {currency} correspondant au prix de votre réservation.",
	"booking.deposit.d": "Une empreinte bancaire d'un montant de {bufferPrice} {currency} sera effectuée lorsque vous confirmerez votre réservation. \nCelle-ci comprend le montant de votre réservation et un montant additionnel permettant de couvrir d'éventuels dépassements.\n\nSans dépassement ni dégât, ne seront débités que les {bookingPrice} {currency} correspondant au prix de votre réservation.",
	"booking.deposit.db": "Deux empreintes bancaire seront effectuées lorsque vous confirmerez votre réservation :\n— Une première d'un montant de {bufferPrice} {currency}, comprenant le montant de votre réservation et un montant additionnel permettant de couvrir d'éventuels dépassements.\n— Une seconde d'un montant de {damageSafetyDeposit} {currency} permettant de couvrir d'éventuels dégâts occasionnés sur le véhicule durant votre réservation.\n\nSans dépassement ni dégât, ne seront débités que les {bookingPrice} {currency} correspondant au prix de votre réservation.",
	"booking.deposit.info": "Une empreinte bancaire sera faite pour votre réservation",
	"booking.payment.prebilling.refused.error": "La transaction a été refusée car le prélèvement sur votre carte bancaire a échoué. Merci de réitérer avec une autre carte. Si le problème persiste, merci de vous renseigner auprès de votre établissement bancaire.",
	"booking.payment.prebilling.technical.error": "Une erreur est survenue lors du paiement. Merci de réessayer ultérieurement.",
	"booking.success.sub.title": "Merci d'utiliser notre service !",
	"booking.success.title": "Félicitations, votre réservation est créée avec succès !",
	"booking.type.label": "Type de réservation",
	"booking.type.one_way": "Aller simple",
	"booking.type.return_trip": "Aller retour",
	"booking.update.period.expired": "La période impartie pour étendre votre réservation est révolu",
	"booking.usage.business": "Professionnel",
	"booking.usage.private": "Privé",
	"booking.view_payment_terms.title": "Modalités de règlement",
	"booking.voucher.different.code": "Vous ne pouvez pas modifier votre code promo",
	"booking.voucher.placeholder": "J'ai un code promo",
	"car.AUTOMATIC": "Automatique",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Électrique",
	"car.FOLDING_SEATS": "Sièges rabattables",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybride",
	"car.LPG": "GPL",
	"car.MANUAL": "Manuel",
	"car.PETROL": "Essence",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Détails réservation",
	"car.color": "Couleur",
	"car.compact_cars": "Compactes",
	"car.description": "Description",
	"car.details": "Détails du véhicule",
	"car.doors": "Portes",
	"car.filter.COMMERCIAL": "Utilitaire",
	"car.filter.PASSENGER": "Tourisme",
	"car.filter.accessories.air_conditioning": "Air conditionné",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Grand coffre",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Nombre de personnes",
	"car.filter.other": "Autres",
	"car.filter.other-nb": "Autres — {nb}",
	"car.filter.vehicle_type": "Type de véhicule",
	"car.filter_energy": "Énergie",
	"car.filter_gearbox_type": "Type de boîte de vitesse",
	"car.filter_persons": "personnes",
	"car.for_every_additional_km": "Par kilomètre supplémentaire",
	"car.km_included": "Km inclus",
	"car.motorization": "Motorisation",
	"car.options": "Options",
	"car.parking_additional_info": "Informations particulières du parking",
	"car.places": "Places",
	"car.pricing": "Tarifications",
	"car.pricing.estimate": "Estimation de prix",
	"car.pricing.extra_km_cost_per_day": "Prix du km supplémentaire",
	"car.pricing.free_km_per_day": "Km inclus / 24 h",
	"car.specifications": "Spécifications",
	"car.transmission": "Transmission",
	"car.utility_cars": "Utilitaires",
	"car.version": "Version",
	"company.id.missing.booking.search": "L'identifiant de l'entreprise est obligatoire pour la recherche de réservation anonyme",
	"contact_page.phone_call_price": "(APPEL GRATUIT DEPUIS UN POSTE FIXE)",
	"contact_page.title_1": "Pour toute question concernant votre location de voiture,",
	"contact_page.title_2": "n'hésitez pas à nous contacter par courriel.",
	"creditcard.data.insufficient.3ds": "En raison des nouvelles exigences 3DS2, nous vous demandons de mettre à jour vos informations de paiement.",
	"custom.field.type.boolean": "Oui/Non",
	"data.with.colon": "{data} :",
	"document.issue.date": "Date d’obtention",
	"dropzone.inner.info": "Fichiers autorisés: JPEG, PNG, PDF",
	"dropzone.inner.title": "Télécharger votre document",
	"error.booking.member_invalid": "Votre profil n'a pas encore été validé.",
	"error.booking.no.usage": "Aucune utilisation pour ces dates de réservation",
	"error.booking.no_credit_card": "Veuillez d'abord ajouter vos informations de carte.",
	"error.booking.same_period": "Vous avez déjà une réservation prévue sur cette période.",
	"error.change_password.400.bad_request": "Le mot de passe est incorrect",
	"error.contract.inactive": "Le service n’est pas actif pour votre entreprise, merci de vous approcher de votre gestionnaire de service.",
	"error.contract.not-found": "Le service est suspendu par votre entreprise, merci de vous approcher de votre gestionnaire de service.",
	"error.credit.card.refused": "Carte de crédit refusée",
	"error.forgot_password.404": "Merci de vérifier votre courriel, aucun compte ne correspond",
	"error.form.email.already_exists": "Merci de renseigner une adresse e-mail différente",
	"error.form.email_invalid": "Merci d'entrer un courriel valide",
	"error.form.inviteCode.notEmpty": "Veuillez renseigner un code d'invitation",
	"error.form.password.at_least": "Votre mot de passe doit contenir 8 caractères minimum",
	"error.form.password.at_most": "Votre mot de passe doit contenir 25 caractères maximum",
	"error.form.password.cannot_reset_same": "Votre nouveau mot de passe doit être différent de l'actuel",
	"error.form.password.digit": "Votre mot de passe doit contenir dont 1 chiffre",
	"error.form.password.lower_letter": "Votre mot de passe doit contenir dont 1 minuscule",
	"error.form.password.upper_letter": "Votre mot de passe doit contenir dont 1 majuscule",
	"error.form.password_confirmation.the_same": "Merci de renseigner le même mot de passe deux fois",
	"error.form.password_old.the_same": "Le nouveau mot de passe doit être différent des précédents mots de passe utilisés",
	"error.form.required": "Merci de renseigner tous les champs",
	"error.form.suggestion.address.required": "Veuillez sélectionner l'adresse dans la liste des suggestions",
	"error.form.technical": "Erreur technique",
	"error.get.site.config": "Échec du chargement de la configuration du site",
	"error.invite.code.invalid": "La communauté que vous souhaitez rejoindre n'existe pas",
	"error.login.401.unauthorized": "Votre courriel ou mot de passe est incorrect",
	"error.login.403.user.anonymized": "Votre compte est en cours d'anonymisation, vous ne pouvez plus l'utiliser",
	"error.login.422.user.not.enabled": "Votre compte n'est pas activé, veuillez vérifier vos courriel et suivre les instructions pour activer votre compte.",
	"error.number.above.max": "La valeur ne peut être supérieure à {value}",
	"error.number.below.min": "La valeur ne peut être inférieure à {value}",
	"error.phone.format.invalid": "Le format du numéro de téléphone n'est pas correct",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Erreur de demande",
	"error.reset_password.401": "Le lien renseigné n’est plus valide, merci de faire une autre demande de mot de passe sur le site",
	"error.search.vehicles.403": "Vous ne pouvez pas accéder au site sélectionné avec le profil actif actuel",
	"error.session.expired": "La session a expiré",
	"error.text.length.long": "Ce champ est limité à {count} caractères",
	"error.text.length.short": "Ce champ nécessite au moins {count} caractères",
	"error.user.verify.fail": "Échec de la vérification de l'utilisateur",
	"error_profile_edit_member_approved": "Le nom et la date de naissance ne peuvent pas être modifiés une fois votre profil validé",
	"faq.contactEmailFallback": "notre email de contact",
	"faq.contactPhoneFallback": "le bas de la page",
	"faq.other_question": "Vous n’avez pas trouvé de réponse à votre question ?",
	"file_upload_size_exceeded": "Le fichier est trop lourd. Taille maximale : 5 Mo",
	"footer.label.legal.information": "Information légale",
	"footer.label.personal.data": "Données personnelles",
	"footer_callUs": "Appelez-nous",
	"footer_other": "Autre",
	"footer_share": "Suivez-nous",
	"footer_society_about": "Qui sommes-nous",
	"footer_society_policy_privacy": "Politique de confidentialité",
	"footer_society_term": "Conditions d'utilisation",
	"footer_writeUs": "Ecrivez-nous",
	"forgot_password.confirmation": "Un lien de réinitialisation de votre mot de passe a été envoyé sur votre courrier électronique.",
	"forgot_password.description_line1": "Saisissez courrier électronique associée à votre compte.",
	"forgot_password.description_line2": "Nous vous enverrons un lien par courrier électronique pour réinitialiser votre mot de passe.",
	"forgot_password.submit": "Recevoir le lien par email",
	"generic.address": "Adresse",
	"generic.at": "à",
	"generic.book": "Réserver",
	"generic.cancel": "Cancel",
	"generic.canceled": "Annulé",
	"generic.city": "Ville",
	"generic.clear": "Réinitialiser",
	"generic.company": "Société",
	"generic.completed": "Terminé",
	"generic.country": "Pays",
	"generic.email": "Courriel",
	"generic.end": "Fin",
	"generic.expires.at": "Expire",
	"generic.extend": "Prolongé",
	"generic.file": "Fichier",
	"generic.first.name": "Prénom",
	"generic.last.name": "Nom",
	"generic.location.fixture.label": "Sites",
	"generic.location.history.label": "Historique",
	"generic.location.search.placeholder": "Rechercher une adresse, une ville ...",
	"generic.mobile.phone": "Téléphone portable",
	"generic.modify": "Modifier",
	"generic.mr": "M.",
	"generic.mrs": "Mme.",
	"generic.next": "Suivant",
	"generic.number": "Nombre",
	"generic.passport": "Passeport",
	"generic.past.placeholder": "Retrouvez ici vos réservations terminées",
	"generic.phone.number": "Numéro de téléphone",
	"generic.postal.code": "Code postal",
	"generic.retry": "Réessayer",
	"generic.save": "Enregistrez",
	"generic.send": "Envoyer",
	"generic.start": "Début",
	"generic.text": "Texte",
	"generic.today": "Maintenant",
	"generic.upcoming": "A venir",
	"generic.updated": "Mis à jour",
	"generic.user": "Utilisateur",
	"get.sso.config.fail": "Cette adresse e-mail n'est pas reconnue pour la connexion SSO",
	"helpPage_carSharing_issue1_answer": "Pour vous inscrire, il vous suffit de vous rendre sur l'intranet du site de votre entreprise, vous trouverez un lien qui vous amènera sur l'interface d'inscription (ou d'envoyer une demande d'inscription à {contactEmail}). Vous recevrez le lien par e-mail.",
	"helpPage_carSharing_issue1_title": "Comment m'inscrire ?",
	"helpPage_carSharing_issue2_answer": "Vous avez la possibilité de réinitialiser votre mot de passe à partir du site web ou des applications mobiles : vous recevrez dans ce cas sur votre adresse e-mail enregistrée un lien pour définir votre nouveau mot de passe.",
	"helpPage_carSharing_issue2_title": "Que faire si j'ai perdu mon mot de passe ?",
	"helpPage_carSharing_issue3_answer": "En cas de badge perdu ou de nouveau badge, merci d'appeler directement la hotline {contactPhone} pour réinitialiser celui-ci.",
	"helpPage_carSharing_issue3_title": "Que faire en cas de badge perdu ou nouveau badge ?",
	"helpPage_carSharing_issue4_answer": "La plaque d'immatriculation de votre véhicule est notée dans l'e-mail de confirmation ainsi que dans le SMS de confirmation. Dans le cas contraire, vous retrouverez le véhicule sur le site de réservation Mes réservations.",
	"helpPage_carSharing_issue4_title": "Quel véhicule ai-je réservé ?",
	"helpPage_carSharing_issue5_answer": "Assurez-vous des dates et horaires, le bouton débuter s'affiche uniquement à partir de l'heure exacte de réservation. Sinon vous pouvez passer votre badge sur le lecteur de badge afin d'ouvrir les portes du véhicule.",
	"helpPage_carSharing_issue5_title": "Pourquoi je ne trouve pas le bouton débuter ?",
	"helpPage_carSharing_issue6_answer": "Si vous avez effectué une réservation, que la lumière passe au vert mais que les portes ne s'ouvrent pas, appuyez sur le bouton qui se trouve sur la poignée de la portière.",
	"helpPage_carSharing_issue6_title": "Pourquoi la lumière est verte mais les portes restent fermées ?",
	"helpPage_carSharing_issue7_answer": "Une fois votre réservation effectuée, il vous est toujours possible de la modifier ou de l'annuler à partir du site web jusqu'à 15 minutes avant l'heure de début de réservation, ou en appelant directement la hotline {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Puis-je modifier ma réservation ?",
	"helpPage_carSharing_issue8_answer": "Vous ne pouvez pas badger en avance. L'ouverture du véhicule ne peut se faire que dans la période de votre réservation (merci d'attendre l'heure exacte au minimum).",
	"helpPage_carSharing_issue8_title": "Puis-je badger en avance ?",
	"helpPage_damages_issue1_answer": "Merci d'utiliser l'application mobile pour nous signaler un dégât. Vous pouvez également appeler la hotline au {contactPhone}.",
	"helpPage_damages_issue1_title": "Que faire en cas de dégât sur le véhicule au démarrage ?",
	"helpPage_damages_issue2_answer": "Restez calme et assurez-vous d'abord qu'il n'y ait pas de blessures corporelles. Dans le cas contraire, merci de contacter les urgences (pompiers 18, Samu). Pour tout dégât matériel, vous êtes couvert par l'assurance. Merci d'appeler la hotline au {contactPhone}.",
	"helpPage_damages_issue2_title": "Que faire en cas de sinistre durant mon utilisation ?",
	"helpPage_subtitle": "Vous trouverez dans cette section les réponses aux questions les plus fréquemment posées.",
	"helpPage_tab_carSharing": "Service",
	"helpPage_tab_damages": "Sinistres",
	"helpPage_tab_vehicles": "Véhicule",
	"helpPage_title": "Foire aux questions (F.A.Q.)",
	"helpPage_vehicles_issue1_answer": "Vérifiez vos dates et horaires de réservation, ensuite vérifiez si la plaque d'immatriculation correspond bien avec votre réservation. Puis badgez de nouveau en présentant devant le lecteur votre badge SEUL. Assurez-vous que le badge que vous utilisez appartient bien à la même personne qui a effectué la réservation et n'a pas été changé entre la dernière réservation et celle-ci. En cas de changement de badge récent, merci de contacter le Service Client pour faire une modification de celui-ci en instantané.",
	"helpPage_vehicles_issue1_title": "Pourquoi le véhicule ne répond pas ?",
	"helpPage_vehicles_issue2_answer": "Vérifiez vos dates et horaires de réservation, ensuite vérifiez si la plaque d'immatriculation correspond bien avec votre réservation. Assurez-vous du bon badge en votre possession (badge de la personne ayant fait la réservation).",
	"helpPage_vehicles_issue2_title": "Lumière rouge, que faire ?",
	"helpPage_vehicles_issue3_answer": "Si vous avez effectué une réservation, que la lumière passe au vert mais que les portes ne s'ouvrent pas, appuyez sur le bouton qui se trouve sur la poignée de la portière.",
	"helpPage_vehicles_issue3_title": "Lumière verte mais portes fermées ?",
	"helpPage_vehicles_issue4_answer": "Vérifiez bien l'immatriculation du véhicule, vos dates et horaires. Assurez-vous d'avoir une connexion Internet suffisante.",
	"helpPage_vehicles_issue4_title": "Pourquoi je n'arrive pas à ouvrir le véhicule ?",
	"helpPage_vehicles_issue5_answer": "Vérifiez bien que le moteur est coupé, les portes ainsi que le coffre bien fermés, que vous avez bien remis les clés avec le petit jeton dans le boitier se trouvant dans la boite à gants ainsi qu'une connexion Internet suffisante.",
	"helpPage_vehicles_issue5_title": "Pourquoi je n'arrive pas à fermer le véhicule ?",
	"home.header_banner": "En octobre, <strong>Renault Mobility</strong> deviendra <strong>Mobilize share</strong>",
	"home.welcome": "Bienvenue sur {productName}",
	"home.welcome_solo": "Bienvenue",
	"how_it_works.step_1": "<span class='bold'>Téléchargez l’application</span> sur l’App Store ou Google Play.",
	"how_it_works.step_2": "Lancez l’application et <span class='bold'>inscrivez-vous</span> en remplissant le formulaire.",
	"how_it_works.step_3": "Photographiez votre <span class='bold'>permis de conduire</span>, votre <span class='bold'>carte d’identité</span> et <span class='bold'>prenez-vous en photo</span> avec votre carte d’identité à côté de votre visage, enregistrez le tout dans l’application !",
	"how_it_works.step_4": "<span class='bold'>Enregistrez votre carte bancaire</span> pour gérer le règlement de vos locations.",
	"how_it_works.step_5": "<span class='bold'>Validez votre adresse courrier</span> en cliquant sur le lien qui vous est envoyé. <span class='bold'>Vérifiez vos pourriels</span>.",
	"how_it_works.step_6": "Une fois votre inscription validée, <span class='bold'>réservez votre véhicule</span> sur notre application ou sur notre site Internet. Le jour de votre réservation, <span class='bold'>votre smartphone est votre clé !</span>",
	"info.account.company.already.linked": "Cette entreprise est déjà liée à votre compte",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Changement de profil",
	"info.worldpay.return.success": "Informations de paiement jointes",
	"iso__BE": "Belgique",
	"iso__CS": "Czechia",
	"iso__DA": "Danish",
	"iso__DE": "Germany",
	"iso__ES": "Espagne",
	"iso__FR": "France",
	"iso__IT": "Italie",
	"iso__NL": "Netherlands",
	"iso__PL": "Poland",
	"iso__PT": "Portugal",
	"iso__SL": "Slovenia",
	"iso__SV": "Sweden",
	"iso__pt_BR": "Brazil",
	"label.accept_terms_and_conditions": "J'accepte d’être contacté(e) ultérieurement par Renault et son réseau par courrier électronique, à des fins d’enquête ou d'information sur les nouveaux produits ainsi que les offres du moment. À l'occasion de chaque envoi, j'aurai la possibilité de mettre fin à toute communication.",
	"label.account.already.active": "Votre compte est déjà actif",
	"label.account_activation_description": "Vous recevrez une confirmation par email lorsque votre compte sera validé et vous pourrez alors profiter pleinement du service.",
	"label.account_activation_title": "Nous avons bien reçu votre inscription, votre demande est en cours de traitement - votre compte sera validé dès que nous aurons examiné votre profil.",
	"label.activation.link.expired": "Le lien d'activation a expiré",
	"label.activation.link.send": "Renvoyer",
	"label.activation.link.sent.success": "L'email d'activation sera envoyé si l'utilisateur existe et le compte n'est pas activé",
	"label.active.profile": "Profil actif",
	"label.actual.payment.method": "Votre moyen de paiement actuel",
	"label.add.new.profile": "Ajouter un nouveau profil",
	"label.apply": "Appliquer",
	"label.are_you_sure_you_want_to_cancel": "Souhaitez-vous confirmer votre annulation ?",
	"label.birth.day": "Date de naissance",
	"label.booking": "Réservation",
	"label.booking.past": "Terminés",
	"label.booking.past.placeholder": "Retrouvez ici votre historique de réservations.",
	"label.booking.today.part": "aujourd'hui à",
	"label.booking.upcoming.placeholder": "Retrouvez ici vos réservations en cours ou à venir",
	"label.cancel_my_booking": "Annuler ma Réservation",
	"label.car": "véhicule",
	"label.carSharing": "Autopartage",
	"label.cars": "véhicules",
	"label.civility": "Civilité",
	"label.click_here": "Cliquer ici",
	"label.close": "Fermer",
	"label.confirm_new_password": "Confirmer le mot de passe",
	"label.congratulations": "Félicitations !",
	"label.continue": "Continuer",
	"label.creditCard_message": "Afin de valider votre carte, un débit temporaire va être réalisé. Un débit d'un faible montant {amountToTake} € peut temporairement apparaître sur le compte associé à votre carte. Si le débit persiste plus de cinq jours ouvrés, veuillez contacter votre banque.",
	"label.date": "Date",
	"label.delivery_place": "Lieu de délivrance",
	"label.driving_licence": "Permis de conduire",
	"label.driving_licence_back": "Permis de conduire - verso",
	"label.driving_licence_front": "Permis de conduire - recto",
	"label.edit.invite.code": "Modifier le code d'invitation",
	"label.expiration_date": "Date d’expiration",
	"label.file.upload.only.mobile": "Pour éditer les documents, merci d’utiliser l’application mobile.",
	"label.filter_by": "Classement par",
	"label.filters": "Filtres",
	"label.generic.error": "Une erreur est survenue. Veuillez réessayer plus tard.",
	"label.hours": "heures",
	"label.how_it_works": "Comment ça marche ?",
	"label.identity.card": "Carte d'identité",
	"label.identity.document.number": "Numéro de document d’identité",
	"label.identity.document.type": "Type de document d'identité",
	"label.identity_card": "Pièce d’identité",
	"label.identity_card_back": "Pièce d'identité - verso",
	"label.identity_card_front": "Pièce d'identité - recto",
	"label.identity_card_selfie": "Selfie avec pièce d'identité",
	"label.invite_code_placeholder": "Entrez votre code d'invitation",
	"label.italy.fiscal.code": "Entrez le numéro fiscal",
	"label.italy.resident": "Vous êtes italien ?",
	"label.licence_number": "N° permis de conduire",
	"label.load_more": "Plus de résultats",
	"label.login": "Se connecter",
	"label.logout": "Se déconnecter",
	"label.manager.email": "E-mail de votre manager",
	"label.mandatory_fields": "* Champs obligatoires",
	"label.member_already": "Déjà membre ?",
	"label.my_account": "Mon compte",
	"label.my_reservations": "Mes réservations",
	"label.new.password": "Nouveau mot de passe",
	"label.no_account": "Nouveau membre ?",
	"label.or_by_phone": "Ou par téléphone",
	"label.password": "Mot de passe",
	"label.password_forgot": "Mot de passe oublié",
	"label.phone": "Téléphone",
	"label.phone.suffix": "Suffixe de téléphone",
	"label.plateNumber": "Numéro d'immatriculation",
	"label.price": "prix",
	"label.redirectMobileApp": "Pour débuter votre réservation, téléchargez notre application mobile !",
	"label.remember_me": "Rester connecté",
	"label.reset_password_done": "Votre mot de passe a été mis à jour",
	"label.return": "Retour",
	"label.schedule": "Horaires",
	"label.search": "Rechercher",
	"label.selected.language": "Langue sélectionnée",
	"label.subject": "Sujet",
	"label.switch.profile": "Changer de profil",
	"label.the": "au",
	"label.validate": "Valider",
	"label.vehicles_found": "{count} résultats trouvés",
	"label.warning": "Attention",
	"label.welcome.finish.registration": "Pour confirmer votre rendez-vous, veuillez terminer votre inscription.",
	"label.you_are_trying_to_cancel_your_booking": "Vous êtes sur le point d’annuler votre réservation !",
	"label.your.active.profile": "Votre profil actif",
	"label.your.other.profiles": "Vos autres profils",
	"label.your_message": "Votre message",
	"language.header": "Choisissez votre langue",
	"login.forgot_password": "Mot de passe oublié ?",
	"login.register": "S’inscrire",
	"menu.faq": "Info",
	"mobile_banner.text": "Téléchargez l’application {productName}",
	"page.password.update.sub.title": "Pour des raisons de sécurité, nous vous demandons de mettre à jour votre mot de passe",
	"page.password.update.title": "Mise à jour du mot de passe",
	"parking.special_opening_legend": "Horaires d'ouverture exceptionnels",
	"part.company.fill.extra.info": "vous demande de remplir quelques informations supplémentaires.",
	"part.complete.register.for": "Terminer votre inscription pour",
	"part.create.account.for": "Créer un compte pour",
	"part.link.account.to": "Liez votre compte à",
	"part.your.email": "votre email",
	"placeholder.enter.number": "Entrez un nombre ...",
	"placeholder.enter.text": "Écrire ici ...",
	"placeholder.search": "Recherche ...",
	"profile.422.error.info": "Il semble que certaines informations manquent dans votre profil.\n Vérifions ensemble votre profil pour nous assurer que tout va bien.",
	"profile.info.new.email": "Si vous mettez à jour votre adresse e-mail, vous recevrez un e-mail pour vérifier votre adresse e-mail. Sans le vérifier, vous ne pourrez plus créer de réservation.",
	"profile.label.before.arrival": "Avant la fin",
	"profile.label.before.departure": "Avant le début",
	"profile.label.charges.call.center": "Changements opérés par une personne du centre d'appel",
	"profile.label.charges.my": "Changements que j'ai effectués",
	"profile.label.current.password": "Mot de passe actuel",
	"profile.label.expiration.date.status": "Mon permis de conduire n'a pas de date d'expiration",
	"profile.label.min.15": "15 minutes",
	"profile.label.min.30": "30 minutes",
	"profile.label.min.45": "45 minutes",
	"profile.label.new.email": "Nouvelle adresse e-mail",
	"profile.label.street.field": "Adresse (numéro de rue + nom de rue)",
	"profile.label.validated.email": "Votre adresse e-mail validée",
	"profile.section.additional.info": "Informations additionnelles",
	"profile.section.credentials": "Identifiants",
	"profile.section.language": "Langue du profil",
	"profile.section.notifications": "Notifications et alertes",
	"profile.section.payment.info": "Informations de paiement",
	"profile.section.personal.info": "Informations personnelles",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Accès technicien",
	"profile.select.menu.item": "Veuillez sélectionner un élément de menu sur la gauche",
	"profile.selfie.section.info": "Veuillez prendre un selfie en montrant votre carte d'identité à côté de votre visage.",
	"profile.suspended": "Votre profil est suspendu",
	"profile.title.email.notifications": "Notifications e-mail",
	"profile.title.language.select": "Langue utilisée pour les notifications et les e-mails",
	"profile.title.sms.notifications": "Notifications par SMS",
	"profile.title.update.email": "Mettez à jour votre adresse e-mail",
	"profile.title.update.password": "Mettre à jour mon mot de passe",
	"profile_error_driver_license_invalid": "Le permis de conduire n'est pas valide",
	"register.field.info.password": "Doit contenir au moins 1 chiffre, 1 lettre majuscule, 1 lettre minuscule et entre 8 et 25 caractères",
	"register.info.payment.saved": "Le moyen de paiement est enregistré.",
	"register.info.profile.creation.forbidden": "Vous ne pouvez pas lier votre profil à cette entreprise",
	"register.success.info": "Un lien d'activation a été envoyé à {email} . Veuillez vérifier vos e-mails et votre dossier spam, puis suivez les instructions pour activer votre compte avant que le lien n'expire.",
	"register.terms.ads": "Je consens au traitement de mes données à des fins marketing (par des méthodes automatisées et traditionnelles) en rapport avec des produits et/ou services de mobilité",
	"register.terms.prefix.accept": "J’accepte",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "politique de confidentialité",
	"register.terms.root.tos": "conditions d'inscription",
	"register.terms.root.tou": "conditions d'utilisation",
	"register.terms.suffix.ads": "utilisation de mes coordonnées à des fins commerciales",
	"register.terms.suffix.of": "de",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Félicitations {firstName}, votre compte a été créé",
	"register.title.account.linked": "Félicitations {firstName}, un nouveau profil a été lié à votre compte",
	"register.title.account.updated": "Félicitations {firstName} , votre compte a été mis à jour",
	"reset_password.title": "Réinitialisation de mot de passe",
	"search.filter_alphabetically": "Alphabétiquement",
	"search.filter_by": "Trier par",
	"search.filter_by_price": "Par prix",
	"search.result.empty": "Il n'y a pas de résultat",
	"service.corporate.intro": "Vous souhaitez rejoindre une communauté ? Veuillez entrer votre code d’invitation.",
	"service.intro_label": "À quel service {productName} souhaitez-vous accéder?",
	"service.private.intro": "Vous souhaitez réserver un véhicule du réseau {productName}?",
	"service.private.renaultfr": "Pour vous inscrire au service {productName}, veuillez vous rendre sur le store de votre smartphone.",
	"service.private.select_country": "Veuillez sélectionner un pays",
	"service.usage.corporate": "Autopartage d'entreprise",
	"service.usage.private": "Location de voitures 24/7",
	"service.usage.vr": "Replacement véhicule",
	"service.vr.intro": "Merci de l'intérêt que vous portez à notre service!\n\n Pour devenir membre, veuillez contacter votre concessionnaire pour obtenir un lien d'inscription.",
	"sncf.home.login.msg": "Vous êtes salarié SNCF? Connectez-vous.",
	"sso.login.description": "Entrez votre adresse e-mail professionnelle",
	"sso.login.title": "Se connecter avec le SSO",
	"status.APPROVED": "Profil validé",
	"status.NOT_APPROVED": "Votre profil est rejeté. Veuillez mettre à jour votre profil.",
	"status.TO_COMPLETE": "Incomplet",
	"status.TO_REVIEW": "Votre profil est en attente de validation",
	"tagline": "La location de voiture en libre-service 24/7",
	"title.add.payment.later": "Vous pouvez ajouter votre moyen de paiement ultérieurement.",
	"title.add.payment.method": "Veuillez ajouter un moyen de paiement.",
	"title.bookings.welcome.tutorial": "Trouvez ici votre réservation, elle est déjà programmée",
	"title.modify.booking": "Modifier ma réservation",
	"title.password.change.success": "Votre nouveau mot de passe a été sauvegardé",
	"title.update.booking": "Mettre à jour la réservation",
	"title.welcome.to.brand": "Bonjour {firstName}, bienvenue sur {brandName}.",
	"title.welcome.to.program": "Bonjour {firstName}, bienvenue au programme {program} {brandName}.",
	"vehicle.incorrect.usage": "Le véhicule n'est pas diponible pour ce type d'utilisation",
	"week.day.friday": "Vendredi",
	"week.day.monday": "Lundi",
	"week.day.saturday": "Samedi",
	"week.day.sunday": "Dimanche",
	"week.day.thursday": "Jeudi",
	"week.day.tuesday": "Mardi",
	"week.day.wednesday": "Mercredi"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/fr.json
 ** module id = 423
 ** module chunks = 0
 **/